import { FC, useState } from "react";
import { FieldValues, useFieldArray, UseFormWatch } from "react-hook-form";
import ModalComponent from "../../../components/organism/Modal/ModalComponent";
import ModalFooterComponent from "../../../components/organism/Modal/ModalFooterComponent";
import { ModalConfig } from "../../../types/Components/Modal/ModalConfig";
import { Box, Button, Flex } from "@chakra-ui/react";
import AccordionGraphField from "./AccordionGraphField";
import { handleSubmitItem } from "../../../helpers/handleSubmitItem";
import api from "../../../utils/api";
import { BULLETIN_INDICATOR_URL } from "../../../utils/endpoints";
import { Toast } from "../../../components/atom/Toast/Toast";

interface ModalBulletinGraphProps {
  handleSubmit: any;
  control: any;
  errors: any;
  modalConfig: ModalConfig;
  watch: UseFormWatch<FieldValues>;
}

const ModalBulletinGraph: FC<ModalBulletinGraphProps> = ({
  handleSubmit,
  control,
  errors,
  modalConfig,
  watch,
}) => {
  const { addToast } = Toast();
  const { isOpen, title = "", buttonTitle, closeModal } = modalConfig;
  const [isLoaded, setIsLoaded] = useState(true);

  const { fields, append, remove } = useFieldArray({
    control,
    name: "graphs",
  });

  const [isAlertOpen, setIsAlertOpen] = useState(false);

  const onSubmit = async (data: FieldValues) => {
    setIsLoaded(false);
    const graphsData = data.graphs;
    const bodyRequest = {
      indicatorGraphs: graphsData
        .filter((graph: any) => {
          return graph.indicatorOptions?.id && graph.typeOption?.id;
        })
        .map((graph: any) => {
          return {
            indicatorId: graph.indicatorOptions.id,
            graphicId: graph.typeOption.id,
          };
        }),
    };

    await handleSubmitItem(
      () => api.put(BULLETIN_INDICATOR_URL, bodyRequest),
      addToast,
    );

    setIsLoaded(true);
    closeModal();
  };

  return (
    <ModalComponent
      isOpen={isOpen}
      onClose={closeModal}
      title={title}
      isAlertOpen={isAlertOpen}
      setIsAlertOpen={setIsAlertOpen}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Flex gap="8" direction="column">
          <Box>
            <Button
              variant="primary"
              onClick={() => append({ indicatorOptions: "", typeOption: "" })}
            >
              Adicionar gráfico
            </Button>
          </Box>
          {fields.map((field, index) => (
            <AccordionGraphField
              key={field.id}
              control={control}
              errors={errors}
              watch={watch}
              index={index}
              remove={() => remove(index)}
            />
          ))}
        </Flex>
        <ModalFooterComponent
          setIsAlertOpen={setIsAlertOpen}
          setIsOpen={closeModal}
          buttonTitle={buttonTitle}
          deleteEnabled={false}
          isLoaded={isLoaded}
        />
      </form>
    </ModalComponent>
  );
};

export default ModalBulletinGraph;
